import { Row, Col } from "react-bootstrap";
import { Typography } from "@mui/material";
import layout from "../../config/layout";

export default function HeroSection() {
  return (
    <Row
      style={{
        marginTop: layout.page.mt,
        marginBottom: "30px",
      }}
    >
      <Col md={12}>
        <Typography
          variant="h3"
          component="h1"
          sx={{
            fontWeight: 800,
            color: "#1a237e",
            letterSpacing: "-0.5px",
            fontSize: { xs: "2.2rem", md: "3.2rem" },
          }}
        >
          Bezpieczna opieka dla Twoich najbliższych
        </Typography>
      </Col>
    </Row>
  );
}
